<div class="row">
  <div class="col-md-12">
    <app-grid-wrapper #contacts [hideLoadingMask]="true"> </app-grid-wrapper>
  </div>
</div>
